import Link from "next/link";
import { AudioLines } from "lucide-react";
import { LEGAL, SERVICE_NAME } from "@/lib/legal";

// Legal only. Pricing, Docs and Contact already sit in the header and the
// side menu; repeating them here would just be a second copy of the same
// navigation. What the footer is actually for is the material that has to be
// reachable from every page — a payment provider checks for exactly that
// before approving a seller, and consumer law expects the terms to be
// findable before someone buys rather than after.
const LINKS = [
  { label: "Terms", href: "/terms" },
  { label: "Privacy", href: "/privacy" },
  { label: "Refunds", href: "/refunds" },
];

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto border-t border-border bg-sidebar">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 py-8 sm:px-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <div className="flex size-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <AudioLines className="size-4" />
          </div>
          <div className="leading-tight">
            <p className="text-sm font-semibold">{SERVICE_NAME}</p>
            <p className="text-xs text-muted-foreground">
              © {year} {LEGAL.operator}
            </p>
          </div>
        </div>

        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {LINKS.map(({ label, href }) => (
            <Link
              key={href}
              href={href}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
